import React from 'react';
import "./CardComunity.scss";
import MediaSocialsComunity from "./MediaSicialsComunity"
import moment from 'moment';
import { Formik } from 'formik'
import PublishAnswerForm from './PublishAnswerForm';
import { validationPublishResponse } from '../../../utils/validations';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { getAnswers } from '../../../store/actions/CommunityAction';
import { responseTimeInCommunity } from '../../../store/actions/UserAction';
import { publishAnswer } from '../../../configs/environments/firebase/firebaseApp';
import { connect } from 'react-redux';

const CardComunityMain  = ({
    body,
    isLawyer,
    getAnswers,
    lawyerUserUid,
    handleSnack,
    responseTimeInCommunity,
    showLoading,
    hideLoading,
}) => {
    const { title, numberAnswers, details, createdAt, userClient, lastReplyDate, topic, id } = body
    let autor = ''
    if (userClient) {
        const { displayName, name, lastName } = userClient
        if (name) {
            autor = `${name} ${lastName ? lastName : ''}`
        } else if (displayName) {
            autor = displayName
        } else {
            autor = ''
        }
    }
    
    let creationDate = ''
    if (createdAt._seconds && createdAt !== undefined) { 
        creationDate = moment.unix(createdAt._seconds).format('DD MMMM YYYY')
    }
    let replyDate = ''
    if (lastReplyDate !== undefined) {
        replyDate = moment.unix(lastReplyDate._seconds).format('DD MMMM YYYY')
    }

    const publishResponse = async (value, { resetForm, setFieldError } ) => {
        try {
            showLoading()
            await publishAnswer(
                id,
                {
                    uidLawyerUsers: lawyerUserUid,
                    response: value.communityAnswer
                }
            )
            await responseTimeInCommunity(lawyerUserUid)
            await getAnswers(id, 1)
            resetForm()
            hideLoading()
            handleSnack('Tu respuesta se ha publicado con éxito')
        } catch (error) {
            console.log('error', error);
            setFieldError('communityAnswer', 'Ocurrió un error')
        }
    }

    const initialValues = {
        communityAnswer: ''
    }
    
    return (
        <div className='comunityMain'>
            <div className='comunityMainContainer'>
                <div className='comunityMain-question'>
                    <div className='comunityMain-title'>
                        {title && title}
                    </div>
                    <p className="comunityMain-subtitle">
                        {topic ? topic : ''}
                    </p>
                    <div className='comunityMain-contentText'>
                        <p className='comunityMain-text'>
                            {details && details}
                        </p>
                    </div>
                </div>
                <div className='comunityMain-contentInfo'>
                    <p className='comunityMain-contentInfo-title'>Autor de la pregunta</p>
                    <p className='comunityMain-contentInfo-text'>{autor}</p>
                    <p className='comunityMain-contentInfo-title'>Fecha de publicación</p>
                    <p className='comunityMain-contentInfo-text'>{creationDate}</p>
                    <p className='comunityMain-contentInfo-title'>No. de respuestas</p>
                    <p className='comunityMain-contentInfo-text'>{numberAnswers ? numberAnswers : 0}</p>
                    <p className='comunityMain-contentInfo-title'>Fecha de última respuesta</p>
                    <p className='comunityMain-contentInfo-text'>{replyDate ? replyDate : ''}</p>
                    <p className='comunityMain-contentInfo-title margin46Top'>Compartir en redes</p>
                    <MediaSocialsComunity />
                </div>
            </div>
            {isLawyer &&
                <div className='comunityMain-answerSection'>
                    <p className='comunityMain-answerSection-title'>
                        Responde a esta pregunta
                    </p>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationPublishResponse}
                        onSubmit={publishResponse}
                        render={props => {
                            return <PublishAnswerForm {...props}/>
                        }}
                    />
                </div>
            }
        </div>
    );
}

const mapStateToProps = state => ({
    lawyerUserUid: state.authClient.uid,
})

const mapDispatchToProps = dispatch => ({
    getAnswers: (questionId, page) => dispatch(getAnswers(questionId, page)),
    responseTimeInCommunity: lawyerUid => dispatch(responseTimeInCommunity(lawyerUid)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})
 
export default connect(mapStateToProps, mapDispatchToProps)(CardComunityMain);